import React from 'react';
import { InlineWidget } from 'react-calendly';
import './CalenderSchedule.css';

const CalenderSchedule = () => {
  return (
    <div className="calender-container">
      <div className="calender-heading">
        <p className="text-justify ">
          If You hire me for your next projects or talk about any kinds of
          Developments work/talk you can feel free to fixed a meeting with me.
        </p>
      </div>
      <div className="calendy-calender">
        {/* <InlineWidget url="https://calendly.com/phrubel42/meeting-for-development" /> */}
        <InlineWidget url="https://calendly.com/phrubel42/freelance-meeting" />
      </div>
    </div>
  );
};

export default CalenderSchedule;
